module.exports = __webpack_public_path__ + "static/media/M152.d7ad62e4.PNG";